import { useEffect } from "react";

/**
 * Escucha la velocidad de scroll y setea data-velocity="fast" en <html>
 * cuando el usuario está scrolleando rápido. Los estilos consumidores
 * pueden acelerar la animación con este attribute. Auto-limpia con debounce.
 * No hace nada en reduced-motion.
 */
export function useScrollVelocity({ threshold = 2500 } = {}) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    let lastY = window.scrollY;
    let lastT = performance.now();
    let timeout = 0;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const now = performance.now();
        const y = window.scrollY;
        const dt = Math.max(1, now - lastT);
        const v = (Math.abs(y - lastY) / dt) * 1000; // px/s
        lastY = y;
        lastT = now;
        if (v > threshold) {
          document.documentElement.setAttribute("data-velocity", "fast");
          if (timeout) window.clearTimeout(timeout);
          timeout = window.setTimeout(() => {
            document.documentElement.removeAttribute("data-velocity");
            timeout = 0;
          }, 260);
        }
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (timeout) window.clearTimeout(timeout);
      document.documentElement.removeAttribute("data-velocity");
    };
  }, [threshold]);
}

export default useScrollVelocity;
